import BrochureFormPaid from '../components/brochureFormPaid';
import InformationFormBasic from '../components/informationFormBasic';
import InformationFormPaid from '../components/informationFormPaid';
import RequestTourForm from '../components/requestTourForm';
import LeadFormType from '../enums/leadFormType';
import AskQuestionFormPaid from '../components/askQuestionFormPaid';
import RequestInformationEntry from '../components/requestInformationEntry';
import GetOnTheListForm from '../components/getOnTheListForm';

const leadGeneratorConstructors = new Map();

leadGeneratorConstructors.set(LeadFormType.BrochureFormPaid.toString(), BrochureFormPaid);
leadGeneratorConstructors.set(LeadFormType.InformationFormPaid.toString(), InformationFormPaid);
leadGeneratorConstructors.set(LeadFormType.RequestTourForm.toString(), RequestTourForm);
leadGeneratorConstructors.set(LeadFormType.InformationFormBasic.toString(), InformationFormBasic);
leadGeneratorConstructors.set(LeadFormType.AskQuestionFormPaid.toString(), AskQuestionFormPaid);
leadGeneratorConstructors.set(LeadFormType.RequestInformation.toString(), RequestInformationEntry);
leadGeneratorConstructors.set(LeadFormType.GetOnTheListForm.toString(), GetOnTheListForm);

/**
 * Returns the class constructor to create a lead generator.
 *
 * @param leadGeneratorName - The name of the lead generator requested.
 */
export default (leadGeneratorName, properties) => {
  const generator = leadGeneratorConstructors.get(leadGeneratorName);

  if (!generator) {
    return null;
  }

  return new generator.prototype.constructor(properties);
};
